import React from "react";
import { ButtonBase, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import Radio from "@mui/material/Radio";

interface FancyRadioButtonProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}

const StyledButtonBase = styled(ButtonBase)<{ selected: boolean }>(
  ({ theme, selected }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderRadius: "8px",
    border: selected ? "3px solid black" : "1px solid black",
    width: "100%",
    textAlign: "left",
    padding: "1rem",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    " & .MuiSvgIcon-root": {
      fontSize: "3rem",
    },
  })
);

const FancyRadioButton: React.FC<FancyRadioButtonProps> = ({
  icon,
  title,
  description,
  selected,
  onClick,
}) => {
  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <StyledButtonBase selected={selected} onClick={onClick}>
        <Box sx={{ mr: 2 }}>{icon}</Box>
        <Box>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2">{description}</Typography>
        </Box>
        <Radio
          checked={selected}
          onChange={onClick}
          value={title}
          name="custom-radio-buttons"
          color="default"
          icon={<span style={{ display: "none" }} />} // Hide default icon
          checkedIcon={<span style={{ display: "none" }} />} // Hide default checked icon
        />
      </StyledButtonBase>
    </Box>
  );
};

export default FancyRadioButton;
